function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg261China(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "167.619,167.43 187.16,227.573 250.399,227.573 199.238,264.744 218.78,324.887    167.619,287.717 116.457,324.887 135.999,264.744 84.837,227.573 148.076,227.573  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "290.787,367.465 271.6,353.525 252.416,367.464 259.743,344.911 240.558,330.971    264.274,330.971 271.6,308.418 278.931,330.971 302.644,330.971 283.459,344.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "340.837,298.576 317.123,298.576 309.794,321.13 302.467,298.577 278.751,298.576    297.938,284.636 290.609,262.084 309.796,276.021 328.981,262.083 321.652,284.636  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "340.837,213.426 321.652,227.366 328.98,249.917 309.796,235.981 290.609,249.919    297.938,227.364 278.752,213.426 302.467,213.425 309.796,190.87 317.123,213.425  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "290.787,144.536 283.46,167.091 302.644,181.029 278.932,181.03 271.602,203.586    264.274,181.029 240.56,181.031 259.745,167.09 252.416,144.535 271.6,158.476  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg261China);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };